import { Category } from '@modules/common/types';

export const getCategoryColor = (category: Category) => {
  switch (category) {
    case Category.Complaint:
      return 'error.dark';
    case Category.Improvement:
      return 'warning.light';
    case Category.Help:
      return 'info.dark';
    case Category.Praise:
      return 'success.dark';
  }
};
